import React, { useState } from 'react';
import { P } from '../../components/typography';
import { useOutletContext } from 'react-router-dom';
import {
  GeneratorHeader,
  GeneratorNavigation,
} from '../../components/generator';
import { SizeConstrained } from '../../components/layout/Layout';
import LevelSelector from '../../components/generator/level-selector/LevelSelector.jsx';
import { useQuery } from '@apollo/client';
import { useParams } from 'react-router';
import { GET_SELECTED_PRODUCTS } from '../../graphql/queries/products';

// NOTE: This is used for both Community and Brochure edit flows

function GeneratorHardware() {
  const { communityData, isCommunityLoaded } = useOutletContext();
  const [selectedIds, setSelectedIds] = useState([]);
  const { id } = useParams();
  const [validationErrors, setValidationErrors] = useState({
    unassignedProducts: null,
  });
  const { data: selectedHardwareData } = useQuery(GET_SELECTED_PRODUCTS, {
    variables: { ids: communityData.uniqueHardwareSelections },
  });

  const validateFields = () => {
    const errors = {
      unassignedProducts: null,
    };

    let uncategorizedObj;
    for (const id in communityData.hardwareLevels) {
      if (
        communityData.hardwareLevels.hasOwnProperty(id) &&
        communityData.hardwareLevels[id].title === 'Uncategorized'
      ) {
        uncategorizedObj = communityData.hardwareLevels[id];
        break;
      }
    }

    const uncategorizedIdsLength = uncategorizedObj?.ids?.length;

    if (uncategorizedIdsLength > 0) {
      errors.unassignedProducts = `All products must be assigned to a level.`;
    }
    setValidationErrors(errors);

    return uncategorizedIdsLength === 0;
  };

  return (
    <div>
      <SizeConstrained>
        <GeneratorHeader title="Define Hardware Levels (Product Tiers)" />
        <P className="mb-5">
          Starting with your base offerings on the left, create additional
          levels to represent your community’s products. Name each level and
          provide a description. Select one or more uncategorized products and
          drag each into a product level.
        </P>
      </SizeConstrained>

      <LevelSelector
        selectedIds={selectedIds}
        setSelectedIds={setSelectedIds}
        itemData={selectedHardwareData?.productCollection.items}
        levelDataKey="hardwareLevels"
        forCabinets={false}
        errors={validationErrors}
      />
      <SizeConstrained>
        <GeneratorNavigation
          nextText={
            communityData.isBrochure
              ? 'Customize Brochure'
              : 'Define Recommendations'
          }
          prevRoute={
            communityData.isBrochure
              ? `/brochure/${id}/cabinets`
              : `/generator/${id}/cabinets`
          }
          nextRoute={
            communityData.isBrochure
              ? `/brochure/${id}/customize`
              : `/generator/${id}/recommendations`
          }
          validateFields={validateFields}
          dataLoaded={isCommunityLoaded}
        />
      </SizeConstrained>
    </div>
  );
}

export default GeneratorHardware;
